import { render, staticRenderFns } from "./properties_help.vue?vue&type=template&id=e5122a5c&"
import script from "./properties_help.vue?vue&type=script&lang=js&"
export * from "./properties_help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports